import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearUserData } from "./store/userSlice";
import useSessionSync from "./hooks/useSessionSync";
import useRefreshUserOnRouteChange from "./hooks/useRefreshUserOnRouteChange";
import { refreshSessionData, registerSessionCryptoKey } from "./utils/refreshSessionData";
import store from "./store";
import App from "./App";
import Maintenance from "./pages/Maintenance";
import axiosInstance from "./utils/axiosInstance";

export default function AppRoot() {
  const dispatch = useDispatch();
  const [underMaintenance, setUnderMaintenance] = useState(null);
  useSessionSync();
  useRefreshUserOnRouteChange();

  useEffect(() => {
    axiosInstance
      .get("/status")
      .then((res) => {
        setUnderMaintenance(res.data && res.data.under_maintenance == 1);
      })
      .catch(() => setUnderMaintenance(false));
  }, []);

  useEffect(() => {
    const loadUser = async () => {
      try {
        // Restore the crypto key into memory first so the very first /user
        // response can be decrypted without a retry roundtrip.
        await registerSessionCryptoKey();
      } catch {
        // Non-fatal — the JWE interceptor will handle re-keying if needed.
      }

      try {
        await refreshSessionData(dispatch);
      } catch (err) {
        console.error("Initial user load failed:", err);
        dispatch(clearUserData());
        return;
      }

      // Safety net: if Redux is still uninitialized after refreshSessionData
      // returned null (meaning a concurrent call "won" the race), wait briefly
      // for that sibling call to dispatch, then force-initialize so the app
      // doesn't stay blank forever (RequireAuth returns null when !initialized).
      setTimeout(() => {
        if (!store.getState().userStore.initialized) {
          dispatch(clearUserData()); // sets initialized:true, data:null → login redirect
        }
      }, 2000);
    };

    loadUser();
  }, [dispatch]);

  if (underMaintenance === null) {
    return null;
  }

  if (underMaintenance) {
    return <Maintenance />;
  }

  return <App />;
}
